import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, mergeProps as _mergeProps, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5458c214"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "layout-topbar-menu" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-user" }, null, -1));
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Profile", -1));
const _hoisted_4 = [
    _hoisted_2,
    _hoisted_3
];
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "pi pi-cog" }, null, -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", null, "Settings", -1));
const _hoisted_7 = [
    _hoisted_5,
    _hoisted_6
];
const _hoisted_8 = { class: "text-primary font-bold" };
const _hoisted_9 = { class: "text-primary font-bold" };
const _hoisted_10 = { class: "ml-2" };
const _hoisted_11 = {
    key: 1,
    class: "ml-auto border-1 surface-border border-round surface-100 text-xs p-1"
};
import { computed, inject, ref } from "vue";
import { useStore } from "@/shared/composables/useStore";
import Menu from "primevue/menu";
import { AllActionTypes } from "@/store/action-types";
import Badge from "primevue/badge";
import { hasMorePrivileges, Roles } from "@/entities/user.entity";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UserMenu',
    setup(__props) {
        const store = useStore();
        const authService = inject("authService");
        const profileMenu = ref();
        const adminMenu = ref();
        const activeMenu = ref("");
        const isActiveMenu = (menu) => activeMenu.value === menu;
        const toggleProfileMenu = (event) => {
            profileMenu.value.toggle(event);
        };
        const toggleAdminMenu = (event) => {
            adminMenu.value.toggle(event);
        };
        const profileItems = ref([
            {
                label: "Profile",
                items: [
                    {
                        label: "Logout",
                        icon: "pi pi-sign-out",
                        command: () => {
                            store.dispatch(AllActionTypes.LOGOUT, authService);
                        },
                    },
                ]
            },
        ]);
        const administrationItems = ref([
            {
                label: "Users",
                role: Roles.SystemAdmin,
                items: [
                    {
                        label: "Accounts",
                        icon: "pi pi-user-edit",
                        command: () => {
                            activeMenu.value = "Accounts";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminUsers");
                        },
                    },
                    {
                        label: "Authorizations",
                        icon: "pi pi-unlock",
                        command: () => {
                            activeMenu.value = "Authorizations";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminAuthorizations");
                        },
                    },
                ],
            },
            {
                label: "Inventory",
                role: Roles.SystemAdmin,
                items: [
                    {
                        label: "Websites", icon: "pi pi-link",
                        command: () => {
                            activeMenu.value = "Websites";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminWebsites");
                        },
                    },
                    {
                        label: "Brands",
                        icon: "pi pi-shopping-cart",
                        command: () => {
                            activeMenu.value = "Brands";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminBrands");
                        },
                    },
                    {
                        label: "Markets",
                        icon: "pi pi-globe",
                        command: () => {
                            activeMenu.value = "Markets";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminMarkets");
                        },
                    },
                ]
            },
            {
                label: "Catalog",
                role: Roles.CatalogAdmin,
                items: [
                    {
                        label: "Services",
                        icon: "pi pi-tags",
                        command: () => {
                            activeMenu.value = "Services";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminCatalogServices");
                        },
                    },
                    {
                        label: "Categories",
                        icon: "pi pi-th-large",
                        command: () => {
                            activeMenu.value = "Categories";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminCatalogCategories");
                        },
                    },
                    {
                        label: "Cards",
                        icon: "pi pi-id-card",
                        command: () => {
                            activeMenu.value = "Cards";
                            store.dispatch(AllActionTypes.NAVIGATE_TO, "AdminCatalogCards");
                        },
                    },
                ]
            }
        ]);
        const userAdminRoles = computed(() => store.getters.adminRoles);
        const administrationItemsForUserRole = computed(() => administrationItems.value.filter((item) => {
            return userAdminRoles.value.some(r => hasMorePrivileges(r, item.role));
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("button", {
                        "data-testid": "user-profile-button",
                        onClick: _cache[0] || (_cache[0] = ($event) => (toggleProfileMenu($event))),
                        class: "p-link layout-topbar-button",
                        "aria-controls": "profile_menu"
                    }, _hoisted_4),
                    (userAdminRoles.value.length)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            "data-testid": "administration-config-button",
                            onClick: _cache[1] || (_cache[1] = ($event) => (toggleAdminMenu($event))),
                            class: "p-link layout-topbar-button",
                            "aria-controls": "admin_menu"
                        }, _hoisted_7))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(_unref(Menu), {
                    id: "profile_menu",
                    "data-testid": "user-menu",
                    ref_key: "profileMenu",
                    ref: profileMenu,
                    class: "onedesk-user-menu",
                    model: profileItems.value,
                    popup: true
                }, {
                    submenuheader: _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(item.label), 1)
                    ]),
                    _: 1
                }, 8, ["model"]),
                _createVNode(_unref(Menu), {
                    id: "admin_menu",
                    "data-testid": "administration-menu",
                    ref_key: "adminMenu",
                    ref: adminMenu,
                    class: "onedesk-user-menu",
                    model: administrationItemsForUserRole.value,
                    popup: true
                }, {
                    submenuheader: _withCtx(({ item }) => [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(item.label), 1)
                    ]),
                    item: _withCtx(({ item, props }) => [
                        _createElementVNode("a", _mergeProps({
                            class: ["flex align-items-center", { 'p-menuitem-active': isActiveMenu(item.label) }]
                        }, props.action), [
                            _createElementVNode("span", {
                                class: _normalizeClass(item.icon)
                            }, null, 2),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.label), 1),
                            (item.badge)
                                ? (_openBlock(), _createBlock(_unref(Badge), {
                                    key: 0,
                                    class: "ml-auto",
                                    value: item.badge
                                }, null, 8, ["value"]))
                                : _createCommentVNode("", true),
                            (item.shortcut)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.shortcut), 1))
                                : _createCommentVNode("", true)
                        ], 16)
                    ]),
                    _: 1
                }, 8, ["model"])
            ], 64));
        };
    }
});
